import { supabase } from '../services/supabaseClient.js';
import { getVisitorId } from './visitorId.js';

// First-party page-view beacon. Fired once per full page load from App.jsx
// (the homegrown router does full reloads, so each route load = one view).
// Fire-and-forget; never blocks or throws. visitor_id is the shared first-party
// id (utils/visitorId.js) — same one events use, so page views and events join
// on visitor_id for funnel attribution. Non-JS bots never run this; headless
// browsers that expose navigator.webdriver are skipped. /admin views are not
// counted.
export function recordPageView() {
  try {
    if (typeof window === 'undefined') return;
    if (navigator.webdriver) return; // skip obvious automated browsers
    // Only record PRODUCTION traffic. Preview deploys (*.vercel.app), localhost,
    // and any test page on another host write to the same Supabase, so without
    // this gate a test page inflates the live page-view + visitor counts.
    if (!/(^|\.)adaptos\.app$/.test(window.location.hostname)) return;
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/admin') return;   // don't count admin's own visits
    supabase
      .from('page_views')
      .insert({
        path,
        visitor_id: getVisitorId(),
        referrer: (document.referrer || '').slice(0, 300) || null,
      })
      .then(() => {}, () => {}); // fire-and-forget, swallow errors
  } catch {
    /* ignore */
  }
}
